// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var GoogleApiHelpers$SmartcutsMacros = require("../GoogleApiHelpers.bs.js");
var GoogleApis__Sheets$SmartcutsMacros = require("../../../bs-googleapis/apis/sheets/GoogleApis__Sheets.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./GoogleSheetsCommand.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./WithElementGroupsCommand.bs.js");
var GoogleApis__Sheets__Schema$SmartcutsMacros = require("../../../bs-googleapis/apis/sheets/GoogleApis__Sheets__Schema.bs.js");
var GoogleApis__Sheets__Values$SmartcutsMacros = require("../../../bs-googleapis/apis/sheets/GoogleApis__Sheets__Values.bs.js");
var GoogleSheetsPlaybackHelpers$SmartcutsMacros = require("./shared/GoogleSheetsPlaybackHelpers.bs.js");
var DataExtraction__ExportToTable$SmartcutsMacros = require("../../../bs-data-extraction/src/DataExtraction__ExportToTable.bs.js");
var GoogleApis__Sheets__BatchUpdate$SmartcutsMacros = require("../../../bs-googleapis/apis/sheets/GoogleApis__Sheets__BatchUpdate.bs.js");

function saveRowsToDestination_encode(v) {
  return Js_dict.fromArray([
              [
                "destination",
                Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_encode, v.destination)
              ],
              [
                "columns",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__ExportToTable$SmartcutsMacros.column_encode(Decco.unitToJson, param);
                      }), v.columns)
              ],
              [
                "maybeExtraColumns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode, param);
                      }), v.maybeExtraColumns)
              ],
              [
                "rows",
                Decco.arrayToJson((function (param) {
                        return Decco.arrayToJson((function (param) {
                                      return DataExtraction__ExportToTable$SmartcutsMacros.cell_encode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_encode, param);
                                    }), param);
                      }), v.rows)
              ]
            ]);
}

function saveRowsToDestination_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var destination = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.destination_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "destination"), null));
  if (destination.TAG === /* Ok */0) {
    var columns = Decco.arrayFromJson((function (param) {
            return DataExtraction__ExportToTable$SmartcutsMacros.column_decode(Decco.unitFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "columns"), null));
    if (columns.TAG === /* Ok */0) {
      var maybeExtraColumns = Decco.optionFromJson((function (param) {
              return Decco.arrayFromJson(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeExtraColumns"), null));
      if (maybeExtraColumns.TAG === /* Ok */0) {
        var rows = Decco.arrayFromJson((function (param) {
                return Decco.arrayFromJson((function (param) {
                              return DataExtraction__ExportToTable$SmartcutsMacros.cell_decode(DataExtraction__ExportToTable$SmartcutsMacros.columnRef_decode, param);
                            }), param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "rows"), null));
        if (rows.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    destination: destination._0,
                    columns: columns._0,
                    maybeExtraColumns: maybeExtraColumns._0,
                    rows: rows._0
                  }
                };
        }
        var e = rows._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".rows" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = maybeExtraColumns._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".maybeExtraColumns" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = columns._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".columns" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = destination._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".destination" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_encode(v) {
  return [
          "SaveRowsToDestination",
          saveRowsToDestination_encode(v._0)
        ];
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SaveRowsToDestination") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = saveRowsToDestination_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* SaveRowsToDestination */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(finalEffect) {
  return "SaveRowsToDestination({destination, columns, rows: [" + (String(finalEffect._0.rows.length) + "]})");
}

function maxColumnLength(rows) {
  return Belt_Array.reduce(rows, 0, (function (maxColumnLength, row) {
                var columnLength = row.length;
                if (columnLength > maxColumnLength) {
                  return columnLength;
                } else {
                  return maxColumnLength;
                }
              }));
}

function makeHeaders(columns, maybeExtraColumns) {
  var arg = Belt_Option.map(maybeExtraColumns, (function (extraColumns) {
          return Belt_Array.map(extraColumns, (function (extraColumn) {
                        if (extraColumn) {
                          return "Saved from web page";
                        } else {
                          return "Saved at date time";
                        }
                      }));
        }));
  return {
          values: Belt_Array.map(Belt_Array.concat(Belt_Array.map(columns, (function (param) {
                          return param.columnName;
                        })), (function (param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                      })([])), (function (value) {
                  return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(value), undefined);
                }))
        };
}

function makeRowDatas(rows, currentUrl, currentDateTime, maybeExtraColumns) {
  var arg = Belt_Option.map(maybeExtraColumns, (function (extraColumns) {
          return Belt_Array.map(extraColumns, (function (extraColumn) {
                        return Curry._3(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.resolveAsCellData, Curry._4(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.fromExtraColumn, extraColumn, currentUrl, Caml_option.some(currentDateTime), undefined), undefined, undefined);
                      }));
        }));
  var extraCells = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
      })([]);
  return Belt_Array.map(rows, (function (row) {
                return {
                        values: Belt_Array.concat(Belt_Array.map(Belt_Array.map(row, (function (param) {
                                        var arg = Belt_Option.map(param.value, DataExtraction__ExportToTable$SmartcutsMacros.resolveCellValueAsText);
                                        var param$1 = "";
                                        return OptionUtils$SmartcutsMacros.withDefault(param$1, arg);
                                      })), (function (value) {
                                    return GoogleApis__Sheets__Schema$SmartcutsMacros.CellData.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.ExtendedValue.stringValue(value), undefined);
                                  })), extraCells)
                      };
              }));
}

function handleGoogleApiHelpersError(errorOnMethodDidThrowPromiseError, error) {
  switch (error.TAG | 0) {
    case /* MethodDidThrowPromiseError */0 :
        return {
                TAG: /* Error */1,
                _0: Curry._1(errorOnMethodDidThrowPromiseError, error.errorType)
              };
    case /* JsExnWhileRemoveCachedOAuthToken */1 :
        return {
                TAG: /* Error */1,
                _0: {
                  TAG: /* CouldNotRemoveCachedOAuthToken */0,
                  _0: error.jsExn
                }
              };
    case /* PromiseErrorWhileGetNewOAuthToken */2 :
        return {
                TAG: /* Error */1,
                _0: /* CouldNotGetNewOAuthToken */0
              };
    
  }
}

function appendRowsToGoogleSheet(client, maybeValueRangeWithoutEnum, spreadsheetId, sheetName, authToken, rows, currentUrl, currentDateTime) {
  var valueRangeWithoutEnum = OptionUtils$SmartcutsMacros.getExn("Expect to get spreadsheet with some sheets", maybeValueRangeWithoutEnum);
  var valueRange = GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRange.fromWithoutEnum(valueRangeWithoutEnum);
  var lastRowIndex = Belt_Array.reduceWithIndex(valueRange.values, 0, (function (lastRowIndex, row, rowIndex) {
          if (row.length !== 1) {
            return rowIndex;
          }
          var match = row[0];
          if (match === "") {
            return lastRowIndex;
          } else {
            return rowIndex;
          }
        }));
  var wrappedSearchMetadata = function (param, param$1) {
    return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                  return GoogleApis__Sheets$SmartcutsMacros.searchDeveloperMetadata(spreadsheetId, accessToken, {
                              dataFilters: Belt_Array.mapWithIndex(Caml_array.make(maxColumnLength(valueRange.values), undefined), (function (colIndex, _v) {
                                      var a1 = GoogleSheetsCommand$SmartcutsMacros.A1.columnForIndexStarting0(colIndex);
                                      return GoogleApis__Sheets__Schema$SmartcutsMacros.DataFilter.a1Range("" + sheetName + "!" + a1 + ":" + a1);
                                    }))
                            }, client);
                }), param, param$1);
  };
  var cell = GoogleSheetsCommand$SmartcutsMacros.A1.fromRowColStarting0(lastRowIndex + 1 | 0, 0);
  var lastCell = GoogleSheetsCommand$SmartcutsMacros.A1.fromRowColStarting0(lastRowIndex + rows.length | 0, maxColumnLength(rows));
  var range = "'" + sheetName + "'!" + cell + ":" + lastCell;
  var wrappedAppend = function (rowsToAppend) {
    return function (param, param$1) {
      return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                    var arg = {
                      range: range,
                      majorDimension: /* Rows */0,
                      values: rowsToAppend
                    };
                    var arg$1 = function (param, param$1, param$2, param$3, param$4, param$5) {
                      var func = Curry.app(GoogleApis__Sheets__Values$SmartcutsMacros.append, [
                            accessToken,
                            param,
                            param$1,
                            param$2,
                            param$3,
                            param$4,
                            param$5,
                            range,
                            spreadsheetId
                          ]);
                      return function (param, param$1) {
                        var func$1 = Curry._4(func, param, param$1, "UserEntered", "InsertRows");
                        return function (param, param$1, param$2) {
                          return Curry._4(func$1, param, param$1, param$2, arg);
                        };
                      };
                    };
                    return Curry._4(arg$1(undefined, undefined, undefined, undefined, undefined, undefined)(undefined, undefined), undefined, undefined, undefined, client);
                  }), param, param$1);
    };
  };
  return wrappedSearchMetadata(authToken, client).then(function (result) {
                var metadata;
                var exit = 0;
                var matchedDeveloperMetadata;
                if (result.TAG === /* Ok */0) {
                  var match = result._0;
                  if (typeof match === "number") {
                    metadata = [];
                  } else if (match.TAG === /* MethodDidReturnUsingOriginalToken */0) {
                    var match$1 = match._0;
                    if (match$1 !== undefined) {
                      matchedDeveloperMetadata = match$1.matchedDeveloperMetadata;
                      exit = 1;
                    } else {
                      metadata = [];
                    }
                  } else {
                    var match$2 = match.return_;
                    if (match$2 !== undefined) {
                      matchedDeveloperMetadata = match$2.matchedDeveloperMetadata;
                      exit = 1;
                    } else {
                      metadata = [];
                    }
                  }
                } else {
                  metadata = [];
                }
                if (exit === 1) {
                  metadata = Belt_Array.map(matchedDeveloperMetadata, (function (param) {
                          return param.developerMetadata;
                        }));
                }
                var rowsToAppend = Belt_Array.map(rows, (function (cells) {
                        var newRow = Caml_array.make(maxColumnLength(rows), undefined);
                        Belt_Array.forEach(metadata, (function (param) {
                                var metadataValue = param.metadataValue;
                                var match = Curry._1(GoogleApis__Sheets__Schema$SmartcutsMacros.DeveloperMetadataLocation.dimensionRangeGet, param.location);
                                switch (param.metadataKey) {
                                  case "columnId" :
                                      if (match === undefined) {
                                        return ;
                                      }
                                      var startIndex = match.startIndex;
                                      var maybeCell = ArrayUtils$SmartcutsMacros.firstMatch((function (param) {
                                              var stringId = String(param.column._0);
                                              return stringId === metadataValue;
                                            }), cells);
                                      return Belt_Option.forEach(maybeCell, (function (param) {
                                                    newRow[startIndex] = Belt_Option.map(param.value, DataExtraction__ExportToTable$SmartcutsMacros.resolveCellValueAsText);
                                                    
                                                  }));
                                  case "extraColumn_serialized" :
                                      if (match === undefined) {
                                        return ;
                                      }
                                      var extraData = Curry._1(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.resolveAsText, Curry._4(DataExtraction__ExportToTable$SmartcutsMacros.GoogleSheet.CellContent.fromExtraColumn, Belt_Result.getExn(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_decode(JSON.parse(metadataValue))), currentUrl, Caml_option.some(currentDateTime), undefined));
                                      newRow[match.startIndex] = extraData;
                                      return ;
                                  default:
                                    return ;
                                }
                              }));
                        return Belt_Array.map(newRow, (function (maybeCellText) {
                                      return OptionUtils$SmartcutsMacros.withDefault("", maybeCellText);
                                    }));
                      }));
                return wrappedAppend(rowsToAppend)(authToken, client);
              }).then(function (result) {
              if (result.TAG === /* Ok */0) {
                var match = result._0;
                if (typeof match === "number") {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* CouldNotGetNewOAuthToken */0
                            });
                }
                if (match.TAG === /* MethodDidReturnUsingOriginalToken */0) {
                  var responseBody = match._0;
                  if (responseBody !== undefined) {
                    return Promise.resolve({
                                TAG: /* Ok */0,
                                _0: {
                                  TAG: /* DidAppendRows */1,
                                  _0: responseBody
                                }
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: /* EmptyResponseBodyAppendRows */1
                              });
                  }
                }
                var responseBody$1 = match.return_;
                if (responseBody$1 !== undefined) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: {
                                TAG: /* DidAppendRows */1,
                                _0: responseBody$1
                              }
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: /* EmptyResponseBodyAppendRows */1
                            });
                }
              } else {
                var error = result._0;
                switch (error.TAG | 0) {
                  case /* MethodDidThrowPromiseError */0 :
                  case /* JsExnWhileRemoveCachedOAuthToken */1 :
                      break;
                  case /* PromiseErrorWhileGetNewOAuthToken */2 :
                      return Promise.resolve({
                                  TAG: /* Error */1,
                                  _0: /* CouldNotGetNewOAuthToken */0
                                });
                  
                }
                return Promise.resolve(handleGoogleApiHelpersError((function (errorType) {
                                  return {
                                          TAG: /* PromiseErrorWhileAppendRows */3,
                                          _0: errorType
                                        };
                                }), error));
              }
            });
}

function execute(currentUrl, finalEffect) {
  var match = finalEffect._0;
  var rows = match.rows;
  var maybeExtraColumns = match.maybeExtraColumns;
  var columns = match.columns;
  var destination = match.destination;
  var currentDateTime = new Date();
  var spreadsheetId;
  var worksheetName;
  if (destination.TAG === /* ExistingGoogleSheet */0) {
    var match$1 = destination._0;
    spreadsheetId = match$1.spreadsheetId;
    worksheetName = match$1.worksheetName;
  } else {
    var spreadsheetName = destination._0;
    if (spreadsheetName.TAG === /* Resolved */0) {
      var match$2 = spreadsheetName._0;
      spreadsheetId = match$2.spreadsheetId;
      worksheetName = match$2.worksheetName;
    } else {
      var spreadsheetName$1 = spreadsheetName._0;
      return GoogleSheetsPlaybackHelpers$SmartcutsMacros.getAuthTokenAndGapiClient(undefined).then(function (param) {
                  var client = param[1];
                  var authToken = OptionUtils$SmartcutsMacros.getExn("Expected auth token", param[0]);
                  var worksheet = GoogleApis__Sheets__Schema$SmartcutsMacros.Sheet.make(undefined, undefined, undefined, undefined, undefined, [{
                          columnMetadata: undefined,
                          rowData: Belt_Array.concat([makeHeaders(columns, maybeExtraColumns)], makeRowDatas(rows, currentUrl, currentDateTime, maybeExtraColumns)),
                          rowMetadata: undefined,
                          startColumn: 0,
                          startRow: 0
                        }], undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                  var wrappedCreate = function (param, param$1) {
                    return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                                  return GoogleApis__Sheets$SmartcutsMacros.create(accessToken, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.Spreadsheet.make(undefined, undefined, GoogleApis__Sheets__Schema$SmartcutsMacros.SpreadsheetProperties.make(undefined, undefined, undefined, undefined, undefined, undefined, spreadsheetName$1, undefined), [worksheet], undefined, undefined, undefined), client);
                                }), param, param$1);
                  };
                  return wrappedCreate(authToken, client).then(function (result) {
                              var createdSpreadsheet;
                              if (result.TAG === /* Ok */0) {
                                var match = result._0;
                                if (typeof match === "number") {
                                  return Promise.resolve({
                                              TAG: /* Error */1,
                                              _0: /* CouldNotGetNewOAuthToken */0
                                            });
                                }
                                if (match.TAG === /* MethodDidReturnUsingOriginalToken */0) {
                                  var createdSpreadsheet$1 = match._0;
                                  if (createdSpreadsheet$1 === undefined) {
                                    return Promise.resolve({
                                                TAG: /* Error */1,
                                                _0: /* EmtpyResponseBodyCreateGoogleSheet */2
                                              });
                                  }
                                  createdSpreadsheet = createdSpreadsheet$1;
                                } else {
                                  var createdSpreadsheet$2 = match.return_;
                                  if (createdSpreadsheet$2 === undefined) {
                                    return Promise.resolve({
                                                TAG: /* Error */1,
                                                _0: /* EmtpyResponseBodyCreateGoogleSheet */2
                                              });
                                  }
                                  createdSpreadsheet = createdSpreadsheet$2;
                                }
                              } else {
                                var error = result._0;
                                var exit = 0;
                                switch (error.TAG | 0) {
                                  case /* MethodDidThrowPromiseError */0 :
                                  case /* JsExnWhileRemoveCachedOAuthToken */1 :
                                      exit = 2;
                                      break;
                                  case /* PromiseErrorWhileGetNewOAuthToken */2 :
                                      return Promise.resolve({
                                                  TAG: /* Error */1,
                                                  _0: /* CouldNotGetNewOAuthToken */0
                                                });
                                  
                                }
                                if (exit === 2) {
                                  return Promise.resolve(handleGoogleApiHelpersError((function (errorType) {
                                                    return {
                                                            TAG: /* PromiseErrorWhileCreateNewGoogleSheet */1,
                                                            _0: errorType
                                                          };
                                                  }), error));
                                }
                                
                              }
                              var arg = Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(createdSpreadsheet.sheets, (function (sheets) {
                                              return Belt_Array.get(sheets, 0);
                                            })), (function (param) {
                                          return param.properties;
                                        })), (function (param) {
                                      return param.sheetId;
                                    }));
                              var sheetId = (function (param) {
                                    return OptionUtils$SmartcutsMacros.getExn(param, arg);
                                  })("Expect to get sheetId after create spreadsheet");
                              var arg$1 = createdSpreadsheet.spreadsheetId;
                              var spreadsheetId = (function (param) {
                                    return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
                                  })("Expect to get spreadsheetId after create spreadsheet");
                              var arg$2 = Belt_Option.map(maybeExtraColumns, (function (extraColumns) {
                                      return Belt_Array.mapWithIndex(extraColumns, (function (offset, extraColumn) {
                                                    var columnIndex = columns.length + offset | 0;
                                                    return {
                                                            metadataId: undefined,
                                                            metadataKey: "extraColumn_serialized",
                                                            metadataValue: JSON.stringify(DataExtraction__ExportToTable$SmartcutsMacros.ExtraColumn.t_encode(extraColumn)),
                                                            location: GoogleApis__Sheets__Schema$SmartcutsMacros.DeveloperMetadataLocation.dimensionRange({
                                                                  sheetId: sheetId,
                                                                  dimension: "Columns",
                                                                  startIndex: columnIndex,
                                                                  endIndex: columnIndex + 1 | 0
                                                                }),
                                                            visibility: "Document"
                                                          };
                                                  }));
                                    }));
                              var developerMetadata = Belt_Array.concat(Belt_Array.mapWithIndex(columns, (function (columnIndex, param) {
                                          return {
                                                  metadataId: undefined,
                                                  metadataKey: "columnId",
                                                  metadataValue: String(param.id),
                                                  location: GoogleApis__Sheets__Schema$SmartcutsMacros.DeveloperMetadataLocation.dimensionRange({
                                                        sheetId: sheetId,
                                                        dimension: "Columns",
                                                        startIndex: columnIndex,
                                                        endIndex: columnIndex + 1 | 0
                                                      }),
                                                  visibility: "Document"
                                                };
                                        })), (function (param) {
                                        return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                                      })([]));
                              var wrappedBatchUpdate = function (param, param$1) {
                                return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                                              return GoogleApis__Sheets$SmartcutsMacros.batchUpdate(spreadsheetId, accessToken, GoogleApis__Sheets__BatchUpdate$SmartcutsMacros.RequestBody.make(Belt_Array.map(developerMetadata, (function (developerMetadata) {
                                                                    return {
                                                                            createDeveloperMetadata: {
                                                                              developerMetadata: developerMetadata
                                                                            }
                                                                          };
                                                                  })), undefined, undefined, undefined, undefined), client);
                                            }), param, param$1);
                              };
                              return wrappedBatchUpdate(authToken, client).then(function (result2) {
                                          if (result2.TAG === /* Ok */0) {
                                            return Promise.resolve({
                                                        TAG: /* Ok */0,
                                                        _0: {
                                                          TAG: /* DidCreateGoogleSheet */0,
                                                          _0: createdSpreadsheet
                                                        }
                                                      });
                                          } else {
                                            return Promise.resolve(handleGoogleApiHelpersError((function (errorType) {
                                                              return {
                                                                      TAG: /* PromiseErrorWhileCreateNewGoogleSheet */1,
                                                                      _0: errorType
                                                                    };
                                                            }), result2._0));
                                          }
                                        });
                            });
                });
    }
  }
  return GoogleSheetsPlaybackHelpers$SmartcutsMacros.getAuthTokenAndGapiClient(undefined).then(function (param) {
              var client = param[1];
              var authToken = OptionUtils$SmartcutsMacros.getExn("Expected auth token", param[0]);
              var wrappedGetValueRange = function (param, param$1) {
                return GoogleApiHelpers$SmartcutsMacros.wrapMethodToHandleInvalidOAuthTokenOrUndefinedGapi((function (accessToken, client) {
                              var arg = "'" + worksheetName + "'";
                              var arg$1 = function (param, param$1, param$2, param$3, param$4, param$5, param$6, param$7) {
                                return Curry.app(GoogleApis__Sheets__Values$SmartcutsMacros.get, [
                                            accessToken,
                                            param,
                                            param$1,
                                            param$2,
                                            param$3,
                                            param$4,
                                            param$5,
                                            param$6,
                                            param$7,
                                            arg,
                                            spreadsheetId
                                          ]);
                              };
                              return Curry._4(arg$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined, undefined, undefined, client);
                            }), param, param$1);
              };
              return wrappedGetValueRange(authToken, client).then(function (result) {
                          if (result.TAG === /* Ok */0) {
                            var maybeValueRangeWithoutEnum = result._0;
                            if (typeof maybeValueRangeWithoutEnum === "number") {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: /* CouldNotGetNewOAuthToken */0
                                        });
                            } else if (maybeValueRangeWithoutEnum.TAG === /* MethodDidReturnUsingOriginalToken */0) {
                              return appendRowsToGoogleSheet(client, maybeValueRangeWithoutEnum._0, spreadsheetId, worksheetName, authToken, rows, currentUrl, currentDateTime);
                            } else {
                              return appendRowsToGoogleSheet(client, maybeValueRangeWithoutEnum.return_, spreadsheetId, worksheetName, maybeValueRangeWithoutEnum.newToken, rows, currentUrl, currentDateTime);
                            }
                          }
                          var error = result._0;
                          switch (error.TAG | 0) {
                            case /* MethodDidThrowPromiseError */0 :
                            case /* JsExnWhileRemoveCachedOAuthToken */1 :
                                break;
                            case /* PromiseErrorWhileGetNewOAuthToken */2 :
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: /* CouldNotGetNewOAuthToken */0
                                          });
                            
                          }
                          return Promise.resolve(handleGoogleApiHelpersError((function (errorType) {
                                            return {
                                                    TAG: /* PromiseErrorWhileAppendRows */3,
                                                    _0: errorType
                                                  };
                                          }), error));
                        });
            });
}

exports.saveRowsToDestination_encode = saveRowsToDestination_encode;
exports.saveRowsToDestination_decode = saveRowsToDestination_decode;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.maxColumnLength = maxColumnLength;
exports.execute = execute;
/* ArrayUtils-SmartcutsMacros Not a pure module */
